import axios from '@/libs/axios'

export default {
    state: {
        services: []
    },
    mutations: {
        setServices(state, services) {
            state.services = services
        },
    },
    actions: {
        getAllServices({
            commit
        }) {
            axios
                .get(`services/getAllServicesAssureur`)
                .then(response => {
                    commit("setServices", response.data)
                })
                .catch(error => console.log(error))
        }
    },
    getters: {
        getServices(state) {
            return state.services
        },
    },
}
